import React, { useRef } from "react";
import { BOX, CONTAINER } from "../about/About";
import { IoCallSharp } from "react-icons/io5";
import { BsWhatsapp } from "react-icons/bs";
import { MdOutlineEmail } from "react-icons/md";
import { BsLinkedin } from "react-icons/bs";
import { FaGithubSquare } from "react-icons/fa";
import emailjs from "emailjs-com";
import styled from "styled-components";
import { COLOR1 } from "../global";

export const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_p7gfpzj",
      "template_uylsmln",
      form.current,
      "tmZ9WOp15CxC-immL"
    );

    e.target.reset();
  };

  return (
    <CONTAINER id="contact">
      <BOX>
        <p>Get In Touch</p>
        <h2>Contact Me</h2>
        <CONTACT_CONTAINER>
          <CONTACT_OPTIONS>
            <CONTACT_OPTION>
              <CONTACT_OPTION_LINK>
                <a href="tel:+918860919561">
                  <IoCallSharp className="contact_option-icon" />
                </a>
              </CONTACT_OPTION_LINK>
              <CONTACT_BY>
                <h4>Phone</h4>
                <small>+91 8860919561</small>
              </CONTACT_BY>
            </CONTACT_OPTION>

            <CONTACT_OPTION>
              <CONTACT_OPTION_LINK>
                <a href="https://github.com/MitreshPrajapati" target="_blank">
                  <FaGithubSquare className="contact_option-icon" />
                </a>
              </CONTACT_OPTION_LINK>
              <CONTACT_BY>
                <h4>Github</h4>
              </CONTACT_BY>
            </CONTACT_OPTION>

            <CONTACT_OPTION>
              <CONTACT_OPTION_LINK>
                <a
                  href="https://www.linkedin.com/in/mitresh-prajapati/"
                  target="_blank"
                >
                  <BsLinkedin />
                </a>
              </CONTACT_OPTION_LINK>
              <CONTACT_BY>
                <h4>LinkedIn</h4>
              </CONTACT_BY>
            </CONTACT_OPTION>

            <CONTACT_OPTION>
              <CONTACT_OPTION_LINK>
                <a href="mailto:mitreshverma@gmail.com" target="_blank">
                  <MdOutlineEmail />
                </a>
              </CONTACT_OPTION_LINK>
              <CONTACT_BY>
                <h4>Gmail</h4>
              </CONTACT_BY>
            </CONTACT_OPTION>
          </CONTACT_OPTIONS>
        </CONTACT_CONTAINER>

        <CONTACT_FORM>
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              name="name"
              placeholder="Your Full Name"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <textarea
              name="message"
              placeholder="Your Message..."
              cols="30"
              rows="10"
              required
            ></textarea>
            <button type="submit" className="btn btn-primary">
              Send Message
            </button>
          </form>
        </CONTACT_FORM>
      </BOX>
    </CONTAINER>
  );
};

const CONTACT_CONTAINER = styled.div`
  width: 100%;
  display: flex;
  padding: 1rem;
  justify-content: center;
  @media screen and (min-width: 300px) and (max-width: 767px) {
    padding: 0.25rem;
  }
`;
const CONTACT_OPTIONS = styled.div`
  width: 65%;
  display: flex;
  justify-content: center;
  gap: 3rem;

  &:nth-child(1) {
    div {
      a {
        font-size: 2rem;
        @media screen and (min-width: 768px) and (max-width: 1024px) {
          font-size: 1.5rem;
        }
        @media screen and (min-width: 300px) and (max-width: 767px) {
          font-size: 1.5rem;
        }
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 900px) {
    flex-direction: column;
    width: 35%;
    gap: 1.5rem;
  }
  @media screen and (min-width: 300px) and (max-width: 767px) {
    flex-direction: column;
    width: 40%;
    gap: 1.5rem;
  }
`;
const CONTACT_OPTION = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  padding: 1rem 0;
  border-radius: 0.5rem;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
`;
const CONTACT_OPTION_LINK = styled.div`
  font-size: 3rem;
  color: black;
  a {
    color: ${COLOR1};
    text-decoration: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    font-size: 2.5rem;
  }
  @media screen and (min-width: 300px) and (max-width: 767px) {
    font-size: 2rem;
  }
`;
const CONTACT_BY = styled.div`
  align-self: center;
  margin: h4 {
    margin-top: -10px;
    font-weight: bold;
  }
  small {
    color: grey;
  }
`;
const CONTACT_FORM = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem;
  form {
    display: flex;
    width: 50%;
    margin-top: 5rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    input {
      width: 100%;
      border: 1px solid ${COLOR1};
      padding: 1rem;
      border-radius: 0.5rem;
    }

    textarea {
      width: 100%;
      border: 1px solid ${COLOR1};
      padding: 1rem;
      border-radius: 0.5rem;
    }

    button {
      width: 106%;
      padding: 1rem 0;
      border-radius: 0.5rem;
      color: white;
      background-color: ${COLOR1};
      font-size: 16px;
      font-weight: semibold;
    }

    /* @media screen and (min-width: 768px) and (max-width: 1024px){
    width: 100%;
   } */
    @media screen and (min-width: 300px) and (max-width: 767px) {
      width: 95%;
    }
  }
`;
